module.exports = __webpack_public_path__ + "static/media/vacancy-graphic.cf7a303c.png";